import React from "react";
import PropTypes from "prop-types";
import { withTheme } from "styled-components";
import { Icon } from "../IconStyled";

export const ToolsIcon = ({ className, theme, type, title }) => {
  const iconColor =
    type === "alternative" ? theme.onSecondaryColor : theme.primaryColor;
  return (
    <Icon className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="50"
        height="50"
        viewBox="0 0 50 50"
      >
        <title>{title}</title>
        <g fill="none" fillRule="nonzero">
          <g fill={iconColor}>
            <path d="M20.225 28.39a.352.352 0 0 0-.496 0l-4.997 5.036a.352.352 0 1 0 .5.497l4.997-5.05a.352.352 0 0 0-.004-.482zM16.401 35.602c.138.137.36.137.497 0l4.993-5.035a.352.352 0 0 0-.5-.497l-4.993 5.032a.352.352 0 0 0 .003.5z" />
            <path d="M37.13 30.408a4.257 4.257 0 0 0-4.366-1.056l-4.838-4.866 6.69-6.725 2.426-.82a.352.352 0 0 0 .23-.244l.823-3.067a.352.352 0 0 0-.091-.352l-1.11-1.12a.352.352 0 0 0-.352-.091l-3.091.87a.352.352 0 0 0-.24.228l-.788 2.42-6.659 6.725-4.637-4.68a4.331 4.331 0 0 0-1.035-4.398 4.257 4.257 0 0 0-4.578-.964.352.352 0 0 0-.12.574l2.018 2.035-1.725 1.736-2.025-2.028a.352.352 0 0 0-.577.123 4.327 4.327 0 0 0 .954 4.616 4.254 4.254 0 0 0 4.366 1.056l4.644 4.666-1.243 1.253-1.137-1.148a.352.352 0 0 0-.5 0l-6.824 6.891a3.521 3.521 0 0 0 0 4.972 3.475 3.475 0 0 0 4.93 0l6.83-6.89a.352.352 0 0 0 0-.497l-1.14-1.152 1.243-1.253 4.838 4.877a4.331 4.331 0 0 0 1.035 4.397 4.254 4.254 0 0 0 4.577.965.352.352 0 0 0 .12-.574l-2.01-2.028 1.725-1.76 2.014 2.031a.352.352 0 0 0 .578-.123 4.331 4.331 0 0 0-.955-4.599zM18.496 19.606a.352.352 0 0 0-.13.024 3.55 3.55 0 0 1-3.827-.806 3.623 3.623 0 0 1-.962-3.331l1.85 1.863a.352.352 0 0 0 .5 0l2.22-2.215a.352.352 0 0 0 0-.497l-1.855-1.87a3.55 3.55 0 0 1 3.296.958 3.627 3.627 0 0 1 .8 3.874.352.352 0 0 0 .08.352l4.8 4.848-1.722 1.736-4.8-4.824a.352.352 0 0 0-.25-.112zm-.704 16.901a2.771 2.771 0 0 1-3.94 0 2.817 2.817 0 0 1 0-3.979l6.57-6.63 3.944 3.975-6.574 6.634zm4.51-9.708l10.691-10.774a.352.352 0 0 0 .084-.138l.758-2.32 2.69-.75.82.827-.725 2.687-2.328.789a.352.352 0 0 0-.137.084L23.468 27.975 22.303 26.8zm15.293 7.43l-1.849-1.863a.352.352 0 0 0-.5 0l-2.218 2.236a.352.352 0 0 0 0 .497l1.849 1.873a3.553 3.553 0 0 1-3.3-.968 3.627 3.627 0 0 1-.799-3.874.352.352 0 0 0-.077-.376l-4.997-5.032L27.43 25l4.993 5.018c.099.1.248.132.38.08a3.553 3.553 0 0 1 3.817.803 3.623 3.623 0 0 1 .972 3.328h.003z" />
          </g>
          <path
            fill={iconColor}
            d="M25 50C11.193 50 0 38.807 0 25S11.193 0 25 0c1.275 0 2.539.096 3.783.284C40.918 2.127 50 12.602 50 25c0 13.807-11.193 25-25 25zm0-.704c13.418 0 24.296-10.878 24.296-24.296 0-12.049-8.827-22.229-20.618-24.02A24.49 24.49 0 0 0 25 .705C11.582.704.704 11.582.704 25S11.582 49.296 25 49.296z"
          />
        </g>
      </svg>
    </Icon>
  );
};

ToolsIcon.propTypes = {
  className: PropTypes.string,
  theme: PropTypes.shape({}).isRequired,
  type: PropTypes.string,
  title: PropTypes.string
};

ToolsIcon.defaultProps = {
  className: "",
  type: "",
  title: "Tools Icon"
};

export default withTheme(ToolsIcon);
